import { Loader2, LocateFixed, ShieldAlert } from "lucide-react";

export function GeoStatusPill({ geoState, coords }) {
  const cls =
    geoState === "granted" ? "border-[#39FF14]/40 text-[#39FF14]"
      : geoState === "denied" ? "border-[#FF007F]/40 text-[#FF007F]"
      : geoState === "prompting" ? "border-[#00E5FF]/40 text-[#00E5FF]"
      : "border-white/15 text-white/50";
  return (
    <div
      data-testid="geo-status-pill"
      className={`inline-flex items-center gap-2 text-[10px] font-mono tracking-widest px-2.5 py-1 rounded-full border ${cls}`}
    >
      {geoState === "granted" && (<><LocateFixed size={11} /> LIVE GPS · ±{Math.round(coords?.accuracy ?? 0)}M</>)}
      {geoState === "prompting" && (<><Loader2 size={11} className="animate-spin" /> LOCKING SATELLITES…</>)}
      {geoState === "denied" && (<><ShieldAlert size={11} /> LOCATION BLOCKED</>)}
      {geoState === "unsupported" && (<><ShieldAlert size={11} /> GPS UNAVAILABLE</>)}
      {geoState === "error" && (<><ShieldAlert size={11} /> SIGNAL LOST</>)}
      {geoState === "idle" && (<><LocateFixed size={11} /> READY</>)}
    </div>
  );
}
